import React from "react";
import Switch from "../components/Switch";

const EnableBox = ({ classes, enabled, onSwitch, event }) => (
  <div className={classes.subContentBox}>
    <div>
      <div className={classes.subContentHead}>Enable Approval Process</div>
      <div className={`${classes.text2} ${classes.marginStyle}`}>
        Enabling this will require {event ? "events" : "e-blasts"} to be approved before scheduling
      </div>
    </div>
    <div className={classes.switchWrapper}>
      <div
        className={classes.switchLabel}
        style={{
          marginRight: 8,
          color: enabled ? "rgba(51, 51, 51, 0.5)" : "#333",
          fontWeight: enabled ? 400 : 600,
        }}
      >
        No
      </div>
      <Switch checked={enabled} onChange={onSwitch} />
      <div
        className={classes.switchLabel}
        style={{
          color: !enabled ? "rgba(51, 51, 51, 0.5)" : "#333",
          fontWeight: !enabled ? 400 : 600,
        }}
      >
        Yes
      </div>
    </div>
  </div>
);

export default EnableBox;
